import styled from '@emotion/styled';

export const Wrapper = styled.div`
  max-width: 600px;
`;
